module.exports = __webpack_public_path__ + "static/media/model-sorento-xm12.9f04d34a.jpg";